import { memo } from 'react'
import { GeoJSON } from 'react-leaflet'

import { FailureFeatures } from '@/services/get-planting-failure-summary-from-diagnosis'

interface FailureLayersProps {
  failures: FailureFeatures[]
  layersFillColor: Record<string, boolean>
}

const FailureLayersComponent = ({
  failures,
  layersFillColor,
}: FailureLayersProps) => {
  return (
    <>
      {failures.map((failure) => {
        const isVisible = !!layersFillColor[failure.layer]

        return (
          <GeoJSON
            key={failure.layer}
            data={failure.geojson}
            style={{
              color: failure.color,
              fillOpacity: isVisible ? 0.2 : 0,
              fill: isVisible,
              weight: isVisible ? 2 : 0,
              opacity: isVisible ? 1 : 0,
              fillRule: 'nonzero' as const,
            }}
          />
        )
      })}
    </>
  )
}

export const FailureLayers = memo(FailureLayersComponent)
